import { render, staticRenderFns } from "./supplierReceiptInvoice.vue?vue&type=template&id=105635e2&scoped=true"
import script from "./supplierReceiptInvoice.vue?vue&type=script&lang=js"
export * from "./supplierReceiptInvoice.vue?vue&type=script&lang=js"
import style0 from "./supplierReceiptInvoice.vue?vue&type=style&index=0&id=105635e2&prod&lang=scss&scoped=true"
import style1 from "./supplierReceiptInvoice.vue?vue&type=style&index=1&id=105635e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105635e2",
  null
  
)

export default component.exports